var exports = {
  "x": "x93eb46d8--38e4c3--button",
};

module.exports = exports;
